// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2Q99h","inputWrap":"CustomTip_inputWrap__vq0QF"};